<template>
    <div>
        <div id="t3m-ObjectiveFinder-filterPanel"
             class="!hidden lg:!block fixed inset-x-0 bottom-0 z-30 space-y-4 overflow-y-auto bg-white t3m-ObjectiveFinder-filterPanel lg:static top-t3m-mainheader lg:overflow-visible lg:bg-transparent">
            <div
                 class="sticky top-0 z-10 flex items-center p-4 space-x-4 bg-white t3m-ObjectiveFinder-filterPanel-actions lg:bg-transparent lg:p-0 lg:static lg:top-auto">
                <span @click="toggleAllFiltersVisible"
                      class="text-xs cursor-pointer t3m-ObjectiveFinder-filterPanel-collapseAll whitespace-nowrap text-primary hover:text-primary-hover">
                    <span v-if="!allFiltersVisible"
                          class="flex items-center space-x-2 ">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 320 512"
                             fill="currentColor"
                             class="w-em h-em">
                            <path
                                  d="M151.5 427.8L3.5 281c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 362.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0zm17-160l148-146.8c4.7-4.7 4.7-12.3 0-17l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L160 202.7 40.3 84.2c-4.7-4.7-12.3-4.7-17 0L3.5 104c-4.7 4.7-4.7 12.3 0 17l148 146.8c4.7 4.7 12.3 4.7 17 0z" />
                        </svg>
                        <span>{{ translations.ShowAll }}</span>
                    </span>
                    <span v-if="allFiltersVisible"
                          class="flex items-center space-x-2">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 320 512"
                             fill="currentColor"
                             class="w-em h-em">
                            <path
                                  d="M168.5 84.2l148 146.8c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L160 149.3 40.3 267.8c-4.7 4.7-12.3 4.7-17 0L3.5 248c-4.7-4.7-4.7-12.3 0-17l148-146.8c4.7-4.7 12.3-4.7 17 0zm-17 160L3.5 391c-4.7 4.7-4.7 12.3 0 17l19.8 19.8c4.7 4.7 12.3 4.7 17 0L160 309.3l119.7 118.5c4.7 4.7 12.3 4.7 17 0l19.8-19.8c4.7-4.7 4.7-12.3 0-17l-148-146.8c-4.7-4.7-12.3-4.7-17 0z" />
                        </svg>
                        <span>{{ translations.CollapseAll }}</span>
                    </span>
                </span>

                <span @click="uncheckAllFilters"
                      class="flex items-center space-x-2 text-xs cursor-pointer t3m-ObjectiveFinder-filterPanel-clearAll whitespace-nowrap text-primary hover:text-primary-hover"
                      :class="{ disabled: hasAppliedFilters }">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 512 512"
                         fill="currentColor"
                         class="w-em h-em">
                        <path
                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z" />
                    </svg>
                    <span>{{ translations.ClearAll }}</span>
                </span>

                <button class="!ml-auto lg:hidden t3m-ObjectiveFinder-filterPanel-toggle btn btn-primary btn-sm flex items-center space-x-2"
                        @click="toggleMobileFilterPanel">

                    <svg xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 512 512"
                         fill="currentColor"
                         class="w-em h-em">
                        <path
                              d="M0 73.7C0 50.67 18.67 32 41.7 32H470.3C493.3 32 512 50.67 512 73.7C512 83.3 508.7 92.6 502.6 100L336 304.5V447.7C336 465.5 321.5 480 303.7 480C296.4 480 289.3 477.5 283.6 472.1L191.1 399.6C181.6 392 176 380.5 176 368.3V304.5L9.373 100C3.311 92.6 0 83.3 0 73.7V73.7zM54.96 80L218.6 280.8C222.1 285.1 224 290.5 224 296V364.4L288 415.2V296C288 290.5 289.9 285.1 293.4 280.8L457 80H54.96z" />
                    </svg>
                    <span>
                        {{ translations.Apply }} <span>({{ this.filteredObjectives.length }})</span>
                    </span>
                </button>
            </div>

            <div class="px-4 pb-4 space-y-4 lg:p-0">
                <div class="pb-2 t3m-ObjectiveFinder-filterPanel-section">
                    <search-filter />
                </div>

                <!-- Checkboxes -->
                <div>
                    <filter-item v-for="(filterItem, name) in filterItems"
                                 :key="name"
                                 :filterItemProperties="filterItem"
                                 v-on:toggleCollapse="getAllFiltersVisible" />

                    <scroll-to-top />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SearchFilter from "@/components/SearchFilter.vue";
import FilterItem from "@/components/FilterItem.vue";
import ScrollToTop from './ScrollToTop.vue';
import { utilities } from "../shared";

export default {
    name: "FilterPanel",
    data() {
        return {
            materialnumber: "",
            allFiltersVisible: false,
        };
    },
    components: {
        SearchFilter,
        FilterItem,
        ScrollToTop
    },
    mixins: [utilities],
    computed: {
        ...mapState(["filterItems", "appliedFilters", "filteredObjectives", "translations"]),
        hasAppliedFilters: function () {
            return Object.values(this.appliedFilters).length > 0;
        },
    },
    methods: {
        ...mapActions(["uncheckAllFilters"]),
        getAllFiltersVisible: function () {
            this.allFiltersVisible = !Object.values(this.filterItems).some((obj) => {
                return obj.collapsed === false;
            });
        },
        toggleAllFiltersVisible: function () {
            this.allFiltersVisible = !this.allFiltersVisible;
            Object.values(this.filterItems).forEach((obj) => {
                obj.collapsed = !this.allFiltersVisible;
            });
        },
    },
};
</script>
